import { ConfluenceWhiteboardAri, ConfluenceDatabaseAri } from '@atlassian/ari';
import { ConfluenceCommentAri } from '@atlassian/ari/confluence/comment';

import {
  type CommentContentType,
  mapCommentContentTypeToResourceType,
  ReactionsResourceType,
} from '../comment-types.ts';
import { type CommentModel } from '../model.ts';
import { getReactionsStore } from '../state/reactions-store.ts';

export const fetchReactions = (
  cloudId: string,
  contentId: string,
  contentType: CommentContentType,
  comments: CommentModel[] = [],
  activationId?: string,
) => {
  const store = getReactionsStore();

  const resourceType =
    mapCommentContentTypeToResourceType(contentType) ?? ReactionsResourceType.whiteboard;

  if (!cloudId || !contentId || !store) {
    return;
  }

  let containerAri;
  if (resourceType === ReactionsResourceType.database) {
    if (activationId === undefined) {
      return;
    }
    containerAri = ConfluenceDatabaseAri.create({
      siteId: cloudId,
      activationId,
      databaseId: contentId,
    });
  } else {
    containerAri = ConfluenceWhiteboardAri.create({
      siteId: cloudId,
      whiteboardId: contentId,
    });
  }

  comments.forEach((comment) => {
    const ari = ConfluenceCommentAri.create({
      commentId: comment.reactionsId,
      siteId: cloudId as string,
    });
    store.getReactions(containerAri.toString(), ari.toString());
  });
};
